<template>
    <div>
        <h1>Settings</h1>
        <router-link to="/settings/lookups">Lookups</router-link>
        <video ref="video" id="video" width="100%" height="100%" autoplay/>
    </div>
</template>

<script>

export default {

    mounted() {
        var breadcrumbs = [];
        breadcrumbs.push ({ name: `Settings`, path: `/settings/`})
        // console.log('breadcrumbs = ' + JSON.stringify(breadcrumbs, null, 2))
        this.MIX_breadcrumbs(breadcrumbs);
this.video = this.$refs.video;
    if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ video: { facingMode: { exact: "environment" } } }).then(stream => {
             video.srcObject = stream;

          let videoElem = document.getElementById("video");
        const qrScanner = new this.$QrScanner(videoElem, result => {
            // console.log('decoded qr code:', result)
            qrScanner.stop();
        });
        qrScanner.start();



                //     video.play();
                // video.onplay = function () {
                // };
                // this.video.play();
        });
    }

    }
}
</script>